import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import API from './api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await API.get('/auth/me');
      setUser(r.data);
      return r.data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await API.post('/auth/login', { email, password });
    setUser(r.data);
    return r.data;
  };

  const register = async (payload) => {
    const r = await API.post('/auth/register', payload);
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await API.post('/auth/logout'); } catch { /* server may already have expired the session — treat as success */ }
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, refresh, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
